import { defineStore } from 'pinia';
import { v4 as uuid } from 'uuid';
import * as action from '@/lib/constants/manuscripts/store';

const useToastMessagesStore = defineStore('manuscript-toast-messages', {
  state: () => ({
    toastMessages: [],
  }),
  getters: {
  },
  actions: {
    [action.ADD_TOAST_MESSAGE](messageObj) {
      const id = uuid();

      this.toastMessages.push({
        ...messageObj,
        id, // Generate a unique ID for each message. This is required to manage individual messages state.
      });

      return id;
    },
    [action.REMOVE_TOAST_MESSAGE](messageId) {
      this.toastMessages = this.toastMessages.filter((msg) => msg.id !== messageId);
    },
  },
});

export default useToastMessagesStore;
